import { useAppDispatch } from '../../../../store';

export const useAddUsersModal = () => {
    const dispatch = useAppDispatch();
    return {};
};
